import { useMutation } from '@tanstack/react-query';
import { type ComparisonItemsActionRequest } from '../../../types/BaselineMeasurements';
import { baselineMeasurementService } from '../../../Domain/BaselineMeasurements/Services';

type DeclineItemsResponse = {};

const mutationFn = async (data: ComparisonItemsActionRequest) => {
  const response = await baselineMeasurementService.declineComparisonItems(data);
  return response.data;
};

export const useDeclineEventsFromComparisonMutation = () => {
  return useMutation<DeclineItemsResponse, unknown, ComparisonItemsActionRequest>(mutationFn);
};
